import {newUTCDate} from './newUTCDate';

const getAdjustedEndOfTaxYear = (todaysDate: Date) => {
  const currentCalendarYear = todaysDate.getUTCFullYear();
  const currentTaxYearEndDate = newUTCDate(`${currentCalendarYear}-04-05`);

  return todaysDate > currentTaxYearEndDate
    ? newUTCDate(`${currentCalendarYear + 1}-04-05`)
    : currentTaxYearEndDate;
};

export default getAdjustedEndOfTaxYear;
